import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { auth } from './firebaseConfig';
import {  Button, Box, Typography  } from '@mui/material';
import { styled } from '@mui/material/styles';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function toBase64Unicode(str) {
  return btoa(
    new Uint8Array(new TextEncoder().encode(str))
      .reduce((data, byte) => data + String.fromCharCode(byte), '')
  );
}


const AdminBatchCreateUsers = ({ fetchUsers }) => {
  const [csvData, setCsvData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  // Validate CSV Data
  const validateCsv = (data) => {
    const validationErrors = [];
    const validData = data.filter(({ username, email, rowIndex }) => {
      if (!username || !email) {
        validationErrors.push({
          row: rowIndex,
          error: 'Missing username or email',
        });
        return false;
      }
  
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email)) {
        validationErrors.push({
          row: rowIndex,
          error: 'Invalid email format',
        });
        return false;
      }
  
      return true;
    });
  
    setErrors(validationErrors);
    return validData;
  };
  
  // Handle CSV File Upload
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
  
    if (file) {
      const reader = new FileReader();
  
      reader.onload = (e) => {
        const text = e.target.result;
  
        // Normalize line endings and split into rows
        const rows = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
  
        // Extract header and data rows
        const [header, ...data] = rows;
  
        // Validate header format
        const headerColumns = header.split(',').map((col) => col.trim());
        if (headerColumns[0] !== 'username' || headerColumns[1] !== 'email') {
          setErrors([{ row: 'Header', error: 'Invalid header format' }]);
          return;
        }
  
        // Parse and clean data rows
        const parsedData = data
          .map((row, index) => {
            const columns = row.split(',').map((col) => col.trim());
            return { username: columns[0] || '', email: columns[1] || '', rowIndex: index + 2 }; // rowIndex for error reporting
          })
          .filter(({ username, email }) => username || email); // Skip empty rows
  
        // Validate the cleaned data
        const validatedData = validateCsv(parsedData);
        setCsvData(validatedData);
        if(errors.length === 0) {
          alert('CSV uploaded successfully, ready to submit');
        }
      };
  
      reader.readAsText(file);
    }
  };
  

  // Handle Firebase Function Call
  const handleSubmit = async () => {
    if (csvData.length === 0) {
      alert('No valid data to upload. Please check the errors and try again.');
      return;
    }

    setIsUploading(true);

    try {
      const functions = getFunctions();
      const batchSignUsers = httpsCallable(functions, 'batchSignUsers');

      const csvContent = csvData
      .map(({ username, email }) => `${username},${email}`)
      .join('\n');
    
    const fullCsv = `username,email\n${csvContent}`;
    const base64CsvContent = toBase64Unicode(fullCsv);
      const organization = auth.currentUser.email.split('@')[1].split('.')[0];
      const subdomain =  process.env.REACT_APP_SUBDOMAIN ? process.env.REACT_APP_SUBDOMAIN : 'www'

      const response = await batchSignUsers({
        csvContent: base64CsvContent,
        organization,
        subdomain
      });

      console.log('Response:', response.data);
      alert('CSV successfully uploaded and processed!');
      setCsvData([]);
    } catch (error) {
      console.error('Error uploading CSV:', error);
      alert('An error occurred while uploading the CSV. Please try again.');
    } finally {
      setIsUploading(false);
      await fetchUsers();
    }
  };

  return (
    <div>
          <Box className="centered-rectangle"         sx={{
      width: 1200,
      height: 300,
      borderRadius: 7, // Rounded corners
      boxShadow: 3, // Optional: Adds shadow for depth
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '50px'
    }}>
                            <Typography variant="h6" component="h6" gutterBottom>
הוסף משתמשים לפי קובץ                                  </Typography>
          <Button
      component="label"
      color="primary"
      className="LoginButton"
      fullWidth
      style={{ marginBottom: '10px', borderRadius: '30px', height: '60px', backgroundColor: 'rgba(255,255,255,0.15)', color: "white"}}
    >
      Upload files
      <VisuallyHiddenInput
        type="file"
        accept=".csv"
        onChange={handleFileUpload}
        multiple
      />
    </Button>

      {errors.length > 0 && (
        <div style={{ color: 'red' }}>
          <h3>Validation Errors</h3>
          <ul>
            {errors.map((error, index) => (
              <li key={index}>
                Row {error.row}: {error.error}
              </li>
            ))}
          </ul>
        </div>
      )}
            <Button
                variant="contained"
                color="primary"
                className="LoginButton"
                fullWidth
                style={{ marginBottom: '10px', borderRadius: '30px', height: '60px', backgroundColor: 'rgba(255,255,255,0.15)', color: "white"}}
              onClick={handleSubmit}
              disabled={isUploading}
            >
              {isUploading ? 'Uploading...' : 'Submit to Firebase'}
            </Button>
      </Box>
    </div>
  );
};

export default AdminBatchCreateUsers;
